// extracted by mini-css-extract-plugin
export default {"RecipeImg":"RecipeInfo_RecipeImg__p+ZcW","Title":"RecipeInfo_Title__asKnk","ListWrapper":"RecipeInfo_ListWrapper__JrwC-"};